import { LoadingOutlined } from '@ant-design/icons';
import { TypedMessages } from '@nxsys/hooks/useTypedIntl';
import { Icons } from '@nxsys/types/icons';
import { BankFilesType } from '@nxsys/types/models/bankFilesReports/bankfiles';
import { IRELAND } from '@nxsys/store/constants/keys';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getColumns = ({
  messages,
  handleDownload,
  handleDownloadBankFile,
  downloadLoadingId,
  isBureau,
  payrollCountry,
}: {
  messages: TypedMessages;
  handleDownload: (record: BankFilesType) => void;
  handleDownloadBankFile: (record: BankFilesType) => void;
  downloadLoadingId?: string | null;
  isBureau?: boolean;
  payrollCountry?: string;
}): ColumnsType<BankFilesType> => {
  const isIreland = payrollCountry === IRELAND;
  return [
    {
      key: 'action',
      title: messages['common.action'],
      fixed: 'left',
      align: 'left',
      render: (record) => (
        <ul className="table-actions flex items-center justify-center">
          <li
            className={downloadLoadingId === record.id ? 'pointer-events-none text-primary-500' : ''}
            onClick={() => handleDownload(record)}
          >
            <Tooltip title={downloadLoadingId === record.id ? 'Loading...' : 'Download'}>
              <span>
                {downloadLoadingId === record.id ? (
                  <LoadingOutlined style={{ fontSize: 16 }} spin />
                ) : (
                  <Icons.IconDownload />
                )}
              </span>
            </Tooltip>
          </li>
          <li
            className={downloadLoadingId === `bank-${record.id}` ? 'pointer-events-none text-primary-500' : ''}
            onClick={() => handleDownloadBankFile(record)}
          >
            <Tooltip title={downloadLoadingId === `bank-${record.id}` ? 'Loading...' : 'Download Bank File'}>
              <span>
                {downloadLoadingId === `bank-${record.id}` ? (
                  <LoadingOutlined style={{ fontSize: 16 }} spin />
                ) : (
                  <Icons.IconFileText />
                )}
              </span>
            </Tooltip>
          </li>
        </ul>
      ),
      width: 100,
    },
    {
      key: 'paymentCompany',
      title: isBureau ? messages['common.employer'] : messages['common.paymentCompany'],
      render: (record) => record.paymentCompany?.companyName,
      width: 200,
    },
    {
      key: 'createdAt',
      title: messages['report.bankFiles.dateDownloaded'],
      align: 'right',
      render: (record) =>
        moment(record.createdAt).tz('Europe/London').format('DD/MM/YYYY'),
      width: 160,
    },
    {
      key: 'paymentProvider',
      title: messages['report.bankFiles.paymentProvider'],
      render: (record) => record.paymentProvider,
      width: 200,
    },
    {
      key: 'noOfRecords',
      title: messages['report.bankFiles.noOfRecords'],
      align: 'right',
      render: (record) => record.noOfRecords,
      width: 200,
    },
    {
      key: 'totalAmount',
      title: messages['report.bankFiles.totalAmount'],
      align: 'right',
      render: (record) => record.totalAmount,
      width: 200,
    },
    ...(!isIreland ? [{
      key: 'downloadedBy',
      title: messages['report.hmrc.cisDeductionsSuffered'],
      render: (record: BankFilesType) =>
        record.downloadedBy.forename + ' ' + record.downloadedBy.surname,
      width: 200,
    }] as ColumnsType<BankFilesType> : []),
  ];
};
